import { AccountManagerMenu } from './AccountManagerMenu';

interface HomeTopBarProps {
  isInboxOpen: boolean;
  onInboxToggle: () => void;
}

export const HomeTopBar = ({ isInboxOpen, onInboxToggle }: HomeTopBarProps) => {
  return (
    <header className="flex h-12 w-full shrink-0 items-center justify-between border-b border-border-secondary bg-bg-primary px-lg">
      <span className="txt-small-medium text-text-primary">Home</span>
      <AccountManagerMenu
        isInboxOpen={isInboxOpen}
        onInboxToggle={onInboxToggle}
      />
    </header>
  );
};
